import { Box } from '@hover/blueprint';
import { useTheme } from '@hover/blueprint/chakra';
import { Component as BlackHoverLogo } from '@hover/tokens-brand/assets/logo-mark--black.svg';
import React from 'react';
import { animated, useSpring } from 'react-spring';

import { LANDSCAPE_TOOLBAR_WIDTH } from 'src/modules/designStudio/components/Toolbar/toolBarConstants';
import { Partner } from 'src/modules/designStudio/helpers/Partner';
import { usePartner } from 'src/modules/designStudio/hooks';
import { Mode } from 'src/modules/designStudio/providers';
import { Link } from 'src/shared/components';
import { useIsLandscape, useMode } from 'src/shared/hooks';

const CONTAINER_DIMENSION = `${LANDSCAPE_TOOLBAR_WIDTH}px`;

const HoverHouseLogo = ({
  activeHomepageLink,
}: {
  activeHomepageLink: boolean;
}) =>
  activeHomepageLink ? (
    <Link isExternal to="/">
      <BlackHoverLogo height="100%" width="100%" />
    </Link>
  ) : (
    <BlackHoverLogo height="100%" width="100%" />
  );

const LandscapeLogo = ({ isLoading }: { isLoading: boolean }) => {
  const theme = useTheme();
  const mode = useMode();
  const partner = usePartner();
  const [isLandscape] = useIsLandscape();
  const fadeInStyle = useSpring({
    opacity: isLoading ? 0 : 1,
    transform: isLoading ? 'scale(1.2)' : 'scale(1)',
  });
  if (mode !== Mode.GUEST || isLoading || !isLandscape) {
    return null;
  }
  return (
    <Box
      alignItems="center"
      height={CONTAINER_DIMENSION}
      justifyContent="center"
      testId="guest-mode-hover-icon"
      width={CONTAINER_DIMENSION}
    >
      <animated.div
        style={{
          ...fadeInStyle,
          // eslint-disable-next-line
          zIndex: theme.zIndices?.popover,
        }}
      >
        <Box height={400}>
          <HoverHouseLogo activeHomepageLink={partner === Partner.DEFAULT} />
        </Box>
      </animated.div>
    </Box>
  );
};

export { LandscapeLogo };
